import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';

type IRemoveLandingPageDesignsToGroup = {
  groupId: number;
  landingPageDesigns: number[];
};

const removeLandingPageDesignsFromGroup = async (
  body: IRemoveLandingPageDesignsToGroup
) => {
  return (
    await EXPRESS_API.post(
      '/superadmin/landing-page-design-groups/remove-batch',
      body
    )
  ).data;
};

export const useRemoveBatchFromGroupMutation = (
  data: IRemoveLandingPageDesignsToGroup
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const isSingular = data.landingPageDesigns.length === 1;

  return useMutation(() => removeLandingPageDesignsFromGroup(data), {
    onSuccess: async () => {
      let message = 'Landing Pages successfully removed from group!';
      if (isSingular) {
        message = 'Landing Page successully removed from group!';
      }
      successToast({
        title: message,
      });
      await queryClient.refetchQueries(landingPageDesignGroupsKeys.all());
      await queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGN_GROUP',
        exact: false,
      });
    },
    onError: error => {
      showError(
        error ||
          `An error occured while trying to remove landing page${isSingular ? '' : 's'} from group.`
      );
    },
  });
};
